import {
  AssignTemplateRequest,
  MailroomShippingLabelTemplate,
  MailroomShippingLabelTemplateResponse,
  PrintLabelResponse,
  PrinterInfo,
  PrinterInfoResponse,
  PrinterList,
  PrinterListResponse,
  ShippingLabelPrintLabelTemplateCreateParams,
  ShippingLabelPrinterInfoListParams,
  ShippingLabelPrinterListListParams,
} from '@apiContract';

import { receivedDigitalApi } from './index';

type PrinterInfoParams = {
  rdConnectInstanceId: number;
  id: number;
};

const shippingLabelApi = receivedDigitalApi.injectEndpoints({
  endpoints: (builder) => ({
    getShippingLabel: builder.query<MailroomShippingLabelTemplate, void>({
      query: () => 'shippingLabel',
      providesTags: ['ConnectInstance'],
      transformResponse: (response: MailroomShippingLabelTemplateResponse): MailroomShippingLabelTemplate =>
        response.objectData,
    }),
    getPrinterList: builder.query<PrinterList, ShippingLabelPrinterListListParams>({
      query: ({ rdConnectInstanceId }) => `ShippingLabel/printer-list?rdConnectInstanceId=${rdConnectInstanceId}`,
      transformResponse: (response: PrinterListResponse): PrinterList => response.objectData,
    }),
    checkPrinterStatus: builder.query<PrinterInfo, ShippingLabelPrinterInfoListParams>({
      query: (params) =>
        `ShippingLabel/printer-info?rdConnectInstanceId=${params.rdConnectInstanceId}&name=${params.name}`,
      transformResponse: (response: PrinterInfoResponse): PrinterInfo => response.objectData,
    }),
    printLabel: builder.mutation<PrintLabelResponse, PrinterInfoParams>({
      query: (requestData) => ({
        url: `ShippingLabel/print-label/${requestData.rdConnectInstanceId}/${requestData.id}`,
        method: 'POST',
      }),
    }),
    applyOptions: builder.mutation<MailroomShippingLabelTemplateResponse, AssignTemplateRequest>({
      query: (requestData) => ({
        url: 'ShippingLabel',
        method: 'POST',
        body: requestData,
      }),
    }),
    testPagePrint: builder.mutation<PrintLabelResponse, ShippingLabelPrintLabelTemplateCreateParams>({
      query: (requestData) => ({
        url: `ShippingLabel/print-label-template?rdConnectInstanceId=${requestData.rdConnectInstanceId}`,
        method: 'POST',
      }),
    }),
  }),
});

export const {
  useGetShippingLabelQuery,
  usePrintLabelMutation,
  useGetPrinterListQuery,
  useCheckPrinterStatusQuery,
  useApplyOptionsMutation,
  useTestPagePrintMutation,
} = shippingLabelApi;
export const { checkPrinterStatus } = shippingLabelApi.endpoints;
